import { IStackItem } from './stack-item.model';
import StackItemView from './stack-item.view';

const StackItemController = (props: IStackItem): JSX.Element => {
  return <StackItemView {...props} />;
};

export default StackItemController;
